import enUSIntl from 'antd/locale/en_US';

export const antdConfig = {
  theme: {
    token: {
      colorPrimary: '#6F2EDE',
    },
  },
  locale: enUSIntl,
};

export const authorizationStatus = {
  STATUS_DELETED: 0,
  STATUS_ACTIVE: 1,
  STATUS_PENDING: 2,
  STATUS_SUBMITTED: 3,
  STATUS_PROCESSED: 4,
};
